export { sentenceCase, snakeCase } from 'change-case';
import strings from 'pluralize';

export const pluralize = strings.plural;
export const singularize = strings.singular;

// Converts a string to its capitalized form (e.g. "hello world" to "Hello world")
export const capitalize = (text: string) => {
  return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
};

// Converts a camelCase string to a titleized string (e.g. "firstName" to "First Name")
export const titleize = (text: string, options = { onlyFirst: false }): string => {
  if (!text) return '';

  const replaced = text.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2');

  if (options.onlyFirst) {
    return capitalize(replaced);
  }

  return replaced
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ');
};

// Converts a string to camelCase (e.g. "hello_world" to "helloWorld")
export const camelize = (text: string): string => {
  return text.replace(/[\W_]+(.)/g, function (_match, chr) {
    // Convert the captured character to uppercase and return it
    return chr.toUpperCase();
  });
};

export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) return '';

  // Remove all non-digit characters from the phone number
  const digits = phoneNumber.replace(/\D/g, '');

  // Format as 912 345 678
  if (digits.length === 9) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
  }

  // Format as +351 912 345 678
  if (digits.length === 12) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '+$1 $2 $3 $4');
  }

  // Return the original phone number if it doesn't match expected formats
  return phoneNumber;
};
